/*
 * @Author: chenxin
 * @Date: 2021-08-26 11:28:52
 * @LastEditTime: 2021-10-26 16:36:30
 * @Description: file content
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const routes = [
  
]

const router = new Router({
  base: '/',
  mode: 'history',
  // mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

// 个性化配置相关  如果跳转到登录页则直接移出token
// router.beforeEach((to,from,next)=>{
//   if(to.path === '/auth/login') {
//     Cookies.remove('privateAccessToken')
//   }
// })

export default router
